// @flow
/**
 * Created by Mike Chung on 2/14/18.
 */
import type {Profile} from "../components/profile/ProfilePage";
import config from "../config/config";

export function setProfile(profile: Profile): void {
    window.localStorage.setItem("profile", JSON.stringify(profile));
}

export function getProfile(): ?Profile {
    return JSON.parse(window.localStorage.getItem("profile"));
}

export function removeProfile(): void {
    window.localStorage.removeItem("profile");
}

export async function removeJwt(): Promise<any> {

    return fetch(`${config.apiGatewayProcotol}://${config.apiGatewayHostname}${config.apiGatewayContext}/saml/logout`, {
        headers: {
            "content-type": "text/plain"
        },
        credentials: "include"
    }).then((response) => {
        if (response.status !== 200) {

            let error = new Error(response.statusText);
            // $FlowFixMe
            error.response = response;
            throw error
        } else {

            return response.json().then((res) => {
                window.location.href = res.logoutUrl;
            });
        }
    });
}


// WEBPACK FOOTER //
// ./src/dao/localStorageProfileDao.js